"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const DoubleArrowRight = _ref => {
  let {
    title = 'Double Right Arrow',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 12"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.87997722,5.72342885 L1.27492829,0.120280408 C1.19476548,0.0401426639 1.10249705,0 0.998270626,0 C0.894044204,0 0.801775772,0.0401426639 0.721612958,0.120280408 L0.120318036,0.721534867 C0.0400075924,0.801672611 -2.66453526e-15,0.893764605 -2.66453526e-15,0.998106014 C-2.66453526e-15,1.10244742 0.0400075924,1.19453942 0.120318036,1.27467716 L4.84726675,6.00014758 L0.120318036,10.7257656 C0.0400075924,10.8059033 -2.66453526e-15,10.8981429 -2.66453526e-15,11.0021892 C-2.66453526e-15,11.1065306 0.0400075924,11.1987701 0.120318036,11.2789079 L0.721612958,11.8798672 C0.801775772,11.9601525 0.894044204,12 0.998270626,12 C1.10249705,12 1.19476548,11.9600049 1.27492829,11.8798672 L6.87982959,6.27671873 C6.95999241,6.19658099 7,6.10434141 7,6.00014758 C7,5.89595376 6.96014004,5.80371418 6.87997722,5.72342885 L6.87997722,5.72342885 Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.8799772,5.72342885 L8.27492829,0.120280408 C8.19476548,0.0401426639 8.10249705,0 7.99827063,0 C7.8940442,0 7.80177577,0.0401426639 7.72161296,0.120280408 L7.12031804,0.721534867 C7.04000759,0.801672611 7,0.893764605 7,0.998106014 C7,1.10244742 7.04000759,1.19453942 7.12031804,1.27467716 L11.8472667,6.00014758 L7.12031804,10.7257656 C7.04000759,10.8059033 7,10.8981429 7,11.0021892 C7,11.1065306 7.04000759,11.1987701 7.12031804,11.2789079 L7.72161296,11.8798672 C7.80177577,11.9601525 7.8940442,12 7.99827063,12 C8.10249705,12 8.19476548,11.9600049 8.27492829,11.8798672 L13.8798296,6.27671873 C13.9599924,6.19658099 14,6.10434141 14,6.00014758 C14,5.89595376 13.96014,5.80371418 13.8799772,5.72342885 L13.8799772,5.72342885 Z"
  })));
};
var _default = exports.default = (0, _ikon.default)(DoubleArrowRight);
DoubleArrowRight.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DoubleArrowRight",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Double Right Arrow'",
        "computed": false
      },
      "required": false
    }
  }
};